/* WOLF BROS – advanced filter drawer behaviour */
(function () {
  if (window.__wbfInit) return;
  window.__wbfInit = true;

  function num(v) {
    var n = parseFloat(String(v || '').replace(/[^0-9.]/g, ''));
    return isNaN(n) ? null : n;
  }
  function parts(box) {
    return {
      max: parseFloat(box.dataset.max) || 0,
      rMin: box.querySelector('.wbf-range__input--min'),
      rMax: box.querySelector('.wbf-range__input--max'),
      fill: box.querySelector('.wbf-range__fill'),
      tMin: box.querySelector('input[name$="gte"]'),
      tMax: box.querySelector('input[name$="lte"]'),
    };
  }
  function paint(box) {
    var p = parts(box);
    if (!p.rMin || !p.max) return;
    p.fill.style.left = (p.rMin.value / p.max) * 100 + '%';
    p.fill.style.right = 100 - (p.rMax.value / p.max) * 100 + '%';
  }
  function filterList(input) {
    var g = input.closest('.wbf-group');
    if (!g) return;
    var q = input.value.trim().toLowerCase();
    g.classList.toggle('is-searching', !!q);
    var shown = 0;
    g.querySelectorAll('.wbf-list > li.wbf-item').forEach(function (li) {
      var ok = !q || (li.dataset.label || '').indexOf(q) > -1;
      li.hidden = !ok;
      if (ok) shown++;
    });
    var e = g.querySelector('.wbf-empty');
    if (e) e.hidden = shown > 0;
  }
  function refresh() {
    document.querySelectorAll('.wbf-price').forEach(paint);
    document.querySelectorAll('.wbf-group:not(.wbf-group--price)').forEach(function (g) {
      var n = g.querySelectorAll('.wbf-list input[type="checkbox"]:checked').length;
      var b = g.querySelector('.wbf-head__badge');
      if (n) {
        if (!b) {
          b = document.createElement('span');
          b.className = 'wbf-head__badge';
          g.querySelector('.wbf-head__label').after(b);
        }
        b.textContent = n;
      } else if (b) b.remove();
      var s = g.querySelector('.wbf-search__input');
      if (s && s.value) filterList(s);
    });
  }

  // Group headers and "Show all" toggles are not <button>s on purpose:
  // the theme's menu-drawer closes the whole drawer when any <button> inside it is clicked.
  function toggle(el) {
    var g = el.closest('.wbf-group');
    if (!g) return;
    if (el.classList.contains('wbf-head')) {
      var collapsed = g.classList.toggle('is-collapsed');
      el.setAttribute('aria-expanded', String(!collapsed));
    } else if (el.classList.contains('wbf-more')) {
      var expanded = g.classList.toggle('is-expanded');
      if (!expanded) g.scrollIntoView({ block: 'nearest' });
    }
  }

  document.addEventListener('click', function (e) {
    var el = e.target.closest && e.target.closest('.wbf-head, .wbf-more');
    if (!el) return;
    e.preventDefault();
    e.stopPropagation();
    toggle(el);
  });

  document.addEventListener(
    'keydown',
    function (e) {
      var t = e.target;
      if (!t.classList) return;
      if (e.key === 'Enter' && t.classList.contains('wbf-search__input')) {
        e.preventDefault();
        return;
      }
      if ((e.key === 'Enter' || e.key === ' ') && (t.classList.contains('wbf-head') || t.classList.contains('wbf-more'))) {
        e.preventDefault();
        toggle(t);
      }
    },
    true
  );

  document.addEventListener(
    'input',
    function (e) {
      var t = e.target;
      if (!t.classList) return;
      if (t.classList.contains('wbf-search__input')) {
        e.stopPropagation();
        filterList(t);
        return;
      }
      var box = t.closest && t.closest('.wbf-price');
      if (!box) return;
      var p = parts(box);
      if (!p.rMin || !p.tMin) return;
      if (t.classList.contains('wbf-range__input')) {
        e.stopPropagation();
        if (+p.rMin.value > +p.rMax.value) {
          if (t === p.rMin) p.rMin.value = p.rMax.value;
          else p.rMax.value = p.rMin.value;
        }
        p.tMin.value = +p.rMin.value > 0 ? p.rMin.value : '';
        p.tMax.value = +p.rMax.value < p.max ? p.rMax.value : '';
        paint(box);
      } else if (t === p.tMin || t === p.tMax) {
        var a = num(p.tMin.value), b = num(p.tMax.value);
        p.rMin.value = a == null ? 0 : a;
        p.rMax.value = b == null ? p.max : b;
        paint(box);
      }
    },
    true
  );

  document.addEventListener(
    'change',
    function (e) {
      var t = e.target;
      if (!t.classList || !t.classList.contains('wbf-range__input')) return;
      e.stopPropagation();
      var p = parts(t.closest('.wbf-price'));
      var target = t === p.rMin ? p.tMin : p.tMax;
      if (target) target.dispatchEvent(new Event('input', { bubbles: true }));
    },
    true
  );

  function observe() {
    var form = document.getElementById('FacetFiltersFormMobile');
    if (!form) return;
    var timer;
    new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(refresh, 30);
    }).observe(form, { childList: true, subtree: true });
    refresh();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observe);
  else observe();
})();